import React from "react";
import { X } from "lucide-react";

const ModalCloseButton = React.forwardRef(
  (
    {
      onClick,
      className = "",
      size = 20,
      ariaLabel = "Close",
      type = "button",
      ...rest
    },
    ref
  ) => {
    return (
      <button
        ref={ref}
        type={type}
        onClick={onClick}
        aria-label={ariaLabel}
        className={`inline-flex h-9 w-9 items-center justify-center rounded-lg border border-slate-200/80 bg-white/70 p-0 text-slate-500 transition-colors hover:border-red-200 hover:bg-red-50 hover:text-red-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#236DB4]/30 ${className}`.trim()}
        {...rest}
      >
        <X className="h-5 w-5" style={{ width: size, height: size }} />
      </button>
    );
  }
);

ModalCloseButton.displayName = "ModalCloseButton";

export default ModalCloseButton;
